export default __webpack_public_path__ + "static/media/eor.a9ca7c3c.png";